import React, { Component } from 'react';
import Translator from '../../../core/i18n';
import { Log, Level, Logger, Display } from 'ng2-logger';
import Submain from '../../../components/home-page-sub-content/submain';
import { Redirect } from 'react-router-dom';
import { Common } from '../../../core/common';
import { ActivityType } from '../../../models/enums/ActivityType';
import { Link, Route } from 'react-router-dom';
import ApiClient from '../../../api/alms-api';
import { Notification } from '../../../components/notification/main';
import ReactGA from 'react-ga4';
import { start } from 'repl';

const T = Translator.create();
const _logger = Log.create('Admin/Main.tsx');
let _common: Common;
let _apiClient: ApiClient;

export class AdminHome extends React.Component<any> {
    state = {
        goToStorageManagementPage: false,
        goToOrganizastionChartPage: false,
        goToMasterCoursePage: false,
        goToTermPage: false,
        goToCoursePage: false,
        goToUserPage: false,
    };

    constructor(props: any) {
        _common = new Common();
        super(props);
        _apiClient = new ApiClient();
    }

    handleClearCache = () => {
        _apiClient
            .RequestAsync('POST', 'api/system/clearcache')
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    Notification.setNotification('success', T.t('r_clear_cache_success_message'), 'topRight');
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_clear_cache_error_message'), 'topRight');
                return false;
            });
    }

    reactGaEvent = (actionName: string)=>{

        ReactGA.event({
            category: window.location.host,
            action: actionName,
            label: actionName,
            nonInteraction: true,
          });
    }

    public render() {
        if (this.state.goToStorageManagementPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/storage-management'} />
        } else if (this.state.goToOrganizastionChartPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/admin-organization-chart'} />
        } else if (this.state.goToMasterCoursePage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/admin-master-course'} />
        } else if (this.state.goToTermPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/admin-term'} />
        } else if (this.state.goToCoursePage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/admin-course'} />
        } else if (this.state.goToUserPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/admin-user'} />
        }

        return (
            <div >
                <div className="student-course">
                    <div className="container" style={{ maxWidth: '1440px' }}>
                        <div className="row">
                            <div className="col-md-9">
                                <div className="d-flex justify-content-between student-course-header pd-top-30">
                                    <div>
                                        <h2 style={{ color: '#323231', fontSize: '20px' }}>{T.t('r_gen_administration_panel')}</h2>
                                    </div>
                                </div>
                                <ul className="student-course-list list-unstyled mt-4 x">
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onMouseDown={() =>
                                                {
                                                    this.reactGaEvent('G_STORAGE_MANAGEMENT_CLICKED');
                                                    this.setState({ goToStorageManagementPage: true })}
                                                }
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div className="report-row-image" style={{ backgroundColor: '#b7f0ff', marginInlineEnd: "10px" }}>
                                                    <i className="material-icons report-row-icon" style={{ color: '#006279' }}>storage </i>
                                                </div>
                                                <div className="list-content d-inline-block list-content-padding-admin admin-list-mobile"  >
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start" }}>
                                                        {T.t('r_gen_storage_management')}
                                                    </h5>
                                                    <p>{T.t('r_gen_storage_management_info')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onMouseDown={() => {
                                                this.reactGaEvent('G_ORGANIZATION_CHART_CLICKED');
                                                this.setState({ goToOrganizastionChartPage: true })
                                            }}
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div className="report-row-image" style={{ backgroundColor: '#fff5e6', marginInlineEnd: "10px" }}>
                                                    <i className="material-icons report-row-icon" style={{ color: '#e69319' }}>star </i>
                                                </div>
                                                <div className="list-content d-inline-block list-content-padding-admin">
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_gen_organization_chart')}
                                                    </h5>
                                                    <p>{T.t('r_gen_organization_schema_management')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 d-flex align-items-center justify-content-end">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_unit')}
                                                </span>
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_program')}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onMouseDown={() =>
                                                {
                                                    this.reactGaEvent('G_MAIN_COURSE_PAGE_CLICKED');
                                                    this.setState({ goToMasterCoursePage: true })}
                                                }
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div className="report-row-image" style={{ backgroundColor: '#e7e4ee', marginInlineEnd: "10px" }}>
                                                <i className="material-icons report-row-icon" style={{ color: '#8a0f0f' }}>collections_bookmark </i>
                                                </div>
                                                <div className="list-content d-inline-block list-content-padding-admin">
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_gen_main_courses')}
                                                    </h5>
                                                    <p>{T.t('r_gen_course_catalogs_management')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 d-flex align-items-center justify-content-end">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_main_course')}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onMouseDown={() => {
                                                this.reactGaEvent('G_TERM_PAGE_CLICKED');
                                                this.setState({ goToTermPage: true })}
                                            }
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div className="report-row-image" style={{ backgroundColor: '#fcccc2', marginInlineEnd: "10px" }}>
                                                    <i className="material-icons report-row-icon" style={{ color: '#8a0f0f' }}>view_list </i>
                                                </div>
                                                <div className="list-content d-inline-block list-content-padding-admin">
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_gen_terms')}
                                                    </h5>
                                                    <p>{T.t('r_gen_training_periods_management')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 d-flex align-items-center justify-content-end">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_questionBank_questionTerm')}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onMouseDown={() => {
                                                this.reactGaEvent('G_COURSE_PAGE_CLICKED');
                                                this.setState({ goToCoursePage: true })}
                                            }
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div className="report-row-image" style={{ backgroundColor: '#d9f0ff', marginInlineEnd: "10px" }}>
                                                     <i className="material-icons report-row-icon" style={{ color: '#8a0f0f' }}>menu_book </i>
                                                </div>
                                                <div className="list-content d-inline-block list-content-padding-admin">
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_gen_courses')}
                                                    </h5>
                                                    <p>{T.t('r_gen_course_content_management')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 d-flex align-items-center justify-content-end">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_course')}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onMouseDown={() => {
                                                this.reactGaEvent('G_USER_PAGE_CLICKED');
                                                this.setState({ goToUserPage: true })}
                                            }
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div className="report-row-image" style={{ backgroundColor: '#e2f4eb', marginInlineEnd: "10px" }}>
                                                    <i className="material-icons report-row-icon" style={{ color: '#3d8f6a' }}>group </i>
                                                </div>
                                                <div className="list-content d-inline-block list-content-padding-admin">
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_gen_users')}
                                                    </h5>
                                                    <p>{T.t('r_gen_system_users_management')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 d-flex align-items-center justify-content-end">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_user')}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex justify-content-between student-course-header pd-top-30">
                                    <div>
                                        <h2 style={{ color: '#323231', fontSize: '20px' }}>{T.t('r_toolbox')}</h2>
                                    </div>
                                </div>
                                <ul className="student-course-list list-unstyled mt-4">
                                    {/* <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + '/u/settingsui'}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start" }}>
                                                        Yeni Ayarlar Sayfası
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li> */}
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + '/Organization/CreateWizard'}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start" }}>
                                                        {T.t('r_editting_settings')}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + '/Activity/RestoreActivity'}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_restore_deleted_activities')}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + '/Exam/AddMultiple'}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_add_batch_exam')}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + '/VirtualClass/UpdateReplayLinks'}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_update_replay_links')}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + '/System/Jobs'}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_background_processes')}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + '/System/LogViewer'}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_logs')}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + '/Role'}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_roles')}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + "/u/globalization/translation"}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_gen_application_texts')}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <Link
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + '/Organization/ManageMenuAndModules'}
                                        >
                                            <div className="col-md-12 align-self-center">
                                                <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                        {T.t('r_menus')}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <a onClick={() => this.handleClearCache()}>
                                            <div style={{ margin: '10px 5px' }}>
                                                <div className="col-md-12 align-self-center">
                                                    <div className="list-content d-inline-block list-content-padding-admin" style={{paddingInlineStart: "10px"}}>
                                                        <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"  }}>
                                                            {T.t('r_clear_cache')}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <Submain />
            </div>
        );
    }
}